// Una pastilla que se pulsa y que, al pasar por encima, saca sus acciones.
//
// Estaba dibujada a mano en `platform-filters`: un `<Button>` con `pr-7` para
// hacer sitio y dos `<button>` crudos encima, cada uno con su `h-5 w-5
// rounded-full shadow-md ring-1` escrito entero. Dos veces, en el mismo bloque.
//
// El relleno que reserva el hueco y el tamano de las acciones viven AQUI, que
// es donde se construyen las piezas, en vez de en la vista -que es justo lo que
// el estandar prohibe-.

import * as React from 'react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export interface AccionDePastilla {
  /** Que hace, en palabras: es el nombre accesible y el tooltip. */
  titulo: string
  icono: React.ReactNode
  onPulsar: (e: React.MouseEvent) => void
  desactivada?: boolean
}

export function PastillaConAcciones({
  acciones,
  activa,
  size = 'sm',
  className,
  children,
  ...props
}: {
  acciones: AccionDePastilla[]
  activa?: boolean
  size?: 'sm' | 'xs'
  className?: string
  children: React.ReactNode
} & Omit<React.ComponentProps<typeof Button>, 'size' | 'variant'>) {
  // Cada accion ocupa 20px y van pegadas: el hueco es el que hagan falta.
  const hueco = acciones.length * 20 + 4
  return (
    <div className="group relative shrink-0 overflow-visible">
      <Button
        variant="ghost"
        size={size}
        className={cn(
          'flex items-center gap-2 transition-colors hover:bg-muted',
          activa && 'border border-primary/20 bg-primary/10 text-primary hover:bg-primary/15',
          className,
        )}
        style={{ paddingRight: hueco }}
        {...props}
      >
        {children}
      </Button>
      {acciones.map((a, i) => (
        <button
          key={a.titulo}
          type="button"
          title={a.titulo}
          aria-label={a.titulo}
          disabled={a.desactivada}
          onClick={(e) => {
            e.stopPropagation()
            a.onPulsar(e)
          }}
          className="absolute top-1/2 z-30 flex h-5 w-5 -translate-y-1/2 items-center justify-center rounded-full bg-background opacity-0 shadow-md ring-1 ring-foreground/20 transition hover:bg-foreground/10 focus-visible:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-50 group-hover:opacity-100"
          style={{ right: 4 + (acciones.length - 1 - i) * 20 }}
        >
          {a.icono}
        </button>
      ))}
    </div>
  )
}
